import * as React from "react";
import generateAuthHeader from "../utils/auth_header";

interface WithHeadersProps {
	httpVerb: string;
	appId?: string;
	children?: (headers: HttpHeadersDict) => any;
	authType?: string;
}

export function getHeaders(
	httpMethod: string,
	appId?: string,
	authType: string = "access_token"
): HttpHeadersDict {
	const headers: HttpHeadersDict = {
		"Content-Type": httpMethod === "GET" ? "application/x-www-form-urlencoded" : "application/json",
		"App-Id": appId || "{app_id}",
	};

	if (typeof window === "object" && authType !== "none") {
		let authToken: string = "";

		if (authToken === "" || authToken === undefined || authToken === null) {
			authToken = authType === "refresh_token" ? "{refresh_token}" : "{access_token}";
			headers.Authorization = `${authToken}`;
		} else {
			headers.Authorization = generateAuthHeader(authType);
		}
	}

	return headers;
}

/**
 * function-as-child component that provides request headers
 */
class WithHeaders extends React.Component<WithHeadersProps, any> {
	render() {
		const headers = getHeaders(this.props.httpVerb, this.props.appId, this.props.authType);

		return this.props.children(headers);
	}
}

export default WithHeaders;



// WEBPACK FOOTER //
// ./src/components/WithHeaders.tsx